'use strict';
'use es6';
/**
 * `fn` is only run one time.
 *
 * @param  {Function} fn
 * @return {any}      the result of the first time `fn` was called
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = once;
function once(fn) {
  var didRun = false;
  var result = void 0;
  return function onced() {
    if (!didRun) {
      didRun = true;
      result = fn.apply(undefined, arguments);
    }
    return result;
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/once.js
// module id = 380
// module chunks = 0 1